import * as config from "./config";
import type { EventDispatcherOptions } from "../typings";
import { sharedDefaultOptions } from "./sharedDefaultOptions";

export const defaultOptions: EventDispatcherOptions = {
  ...sharedDefaultOptions,
  collectorPath: config.COLLECTOR_PATH_BROWSER,
};
